export const MY_COURSES_REQUEST = "MY_COURSES_REQUEST";
export const MY_COURSES_SUCCESS = "MY_COURSES_SUCCESS";
export const MY_COURSES_FAIL = "MY_COURSES_FAIL";

export const ALL_COURSES_REQUEST = "ALL_COURSES_REQUEST";
export const ALL_COURSES_SUCCESS = "ALL_COURSES_SUCCESS";
export const ALL_COURSES_FAIL = "ALL_COURSES_FAIL";

export const ENROLL_COURSE_REQUEST = "ENROLL_COURSE_REQUEST";
export const ENROLL_COURSE_SUCCESS = "ENROLL_COURSE_SUCCESS";
export const ENROLL_COURSE_FAIL = "ENROLL_COURSE_FAIL";

export const SSO_LOGIN_REQUEST = "SSO_LOGIN_REQUEST";
export const SSO_LOGIN_SUCCESS = "SSO_LOGIN_SUCCESS";
export const SSO_LOGIN_FAIL = "SSO_LOGIN_FAIL";

export const USER_REPORT_REQUEST = "USER_REPORT_REQUEST";
export const USER_REPORT_SUCCESS = "USER_REPORT_SUCCESS";
export const USER_REPORT_FAIL = "USER_REPORT_FAIL";

export const COURSE_DATA_REQUEST = "COURSE_DATA_REQUEST";
export const COURSE_DATA_SUCCESS = "COURSE_DATA_SUCCESS";
export const COURSE_DATA_FAIL = "COURSE_DATA_FAIL";

export const COURSE_LANDING_PAGE_DATA_REQUEST = "COURSE_LANDING_PAGE_DATA_REQUEST"
export const COURSE_LANDING_PAGE_DATA_SUCCESS = "COURSE_LANDING_PAGE_DATA_SUCCESS"
export const COURSE_LANDING_PAGE_DATA_FAIL = "COURSE_LANDING_PAGE_DATA_FAIL"

export const ALL_COURSE_LANDING_PAGE_DATA_REQUEST = "ALL_COURSE_LANDING_PAGE_DATA_REQUEST"
export const ALL_COURSE_LANDING_PAGE_DATA_SUCCESS = "ALL_COURSE_LANDING_PAGE_DATA_SUCCESS"
export const ALL_COURSE_LANDING_PAGE_DATA_FAIL = "ALL_COURSE_LANDING_PAGE_DATA_FAIL"

export const PAYMENT_DATA_REQUEST = "PAYMENT_DATA_REQUEST"
export const PAYMENT_DATA_SUCCESS = "PAYMENT_DATA_SUCCESS"
export const PAYMENT_DATA_FAIL = "PAYMENT_DATA_FAIL"

export const GET_PAYMENT_DATA_REQUEST = "GET_PAYMENT_DATA_REQUEST"
export const GET_PAYMENT_DATA_SUCCESS = "GET_PAYMENT_DATA_SUCCESS"
export const GET_PAYMENT_DATA_FAIL = "GET_PAYMENT_DATA_FAIL"

export const COURSE_PAYMENT_REQUEST = "COURSE_PAYMENT_REQUEST"
export const COURSE_PAYMENT_SUCCESS = "COURSE_PAYMENT_SUCCESS"
export const COURSE_PAYMENT_FAIL = "COURSE_PAYMENT_FAIL"

export const COURSE_PAYMENT_STATUS_REQUEST = "COURSE_PAYMENT_STATUS_REQUEST" 
export const COURSE_PAYMENT_STATUS_SUCCESS = "COURSE_PAYMENT_STATUS_SUCCESS" 
export const COURSE_PAYMENT_STATUS_FAIL = "COURSE_PAYMENT_STATUS_FAIL" 

export const CLEAR_ERRORS = "CLEAR_ERRORS";

export const ALL_NOTICEBOARDS_FAIL = "ALL_NOTICEBOARDS_FAIL" 
export const ALL_NOTICEBOARDS_SUCCESS = "ALL_NOTICEBOARDS_SUCCESS"
export const ALL_NOTICEBOARDS_REQUEST = "ALL_NOTICEBOARDS_REQUEST"